import { useEffect, useState, MutableRefObject } from 'react';

type Size = {
  width?: number;
  height?: number;
};

const isSizeSame = ({ offsetWidth, offsetHeight }: HTMLElement, { width, height }: Size) =>
  width === offsetWidth && height === offsetHeight;

const getSizeFromOffset = (element: HTMLElement | null) => {
  const { offsetWidth, offsetHeight } = element || {
    offsetWidth: undefined,
    offsetHeight: undefined
  };

  return {
    width: offsetWidth,
    height: offsetHeight
  };
};

const calcSize = (element: HTMLElement, size: Size, onSizeChange: (size: Size) => void) => {
  const isElementPainted = !!element.offsetHeight;

  if (!isElementPainted || isSizeSame(element, size)) return;

  onSizeChange(getSizeFromOffset(element));
};

const useMemorizeSize = (ref: MutableRefObject<HTMLDivElement | null>) => {
  const [size, setSize] = useState<Size>({
    width: undefined,
    height: undefined
  });
  const { width: offsetWidth, height: offsetHeight } = getSizeFromOffset(ref.current);

  useEffect(() => {
    ref.current && calcSize(ref.current, size, setSize);
  }, [offsetWidth, offsetHeight]);

  return size;
};

export default useMemorizeSize;
